/**
 * @generated SignedSource<<c04b23648b1720425eba6ca5ffdb4c66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type genericTaskContextMenu_company$data = {
  readonly id: string;
  readonly jiraCloudEnabled: boolean | null;
  readonly jiraServerEnabled: boolean | null;
  readonly integrations: {
    readonly jiraCloud: {
      readonly syncSettings: {
        readonly isJiraToForecastOneWaySync: boolean | null;
      } | null;
    } | null;
    readonly jiraServer: {
      readonly syncSettings: {
        readonly isJiraToForecastOneWaySync: boolean | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "genericTaskContextMenu_company";
};
export type genericTaskContextMenu_company$key = {
  readonly " $data"?: genericTaskContextMenu_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"genericTaskContextMenu_company">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "JiraSyncSettingsType",
    "kind": "LinkedField",
    "name": "syncSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isJiraToForecastOneWaySync",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "genericTaskContextMenu_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraCloudEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraServerEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyIntegrationsType",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyJiraSettingsType",
          "kind": "LinkedField",
          "name": "jiraCloud",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyJiraSettingsType",
          "kind": "LinkedField",
          "name": "jiraServer",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "e983c3b19f620d889db701d1169384f3";

export default node;
